import { RQ } from 'utils';

export default {
  getInfo: async function (activityId) {
    let self = this;
    let d = await RQ.mall.get(`/api/h5/activity/getActivityRule`,{activityId});
    if (d && d.code == 0) {
      self.info = d.data;
    }
  }
};



// WEBPACK FOOTER //
// ./src/module/app/fissionShareRules/action.js